import { useEffect, useMemo, useState } from 'react';
import './App.css';

const COMPLETION_DEADLINE = new Date('2025-10-31T23:59:59+09:00');

const CAPTIONS = ['工期未定', '继续烂尾中', 'Indefinitely delayed'];

const WORKERS = [
  '@0_a_e',
  'Qwen',
  'GLM',
  'Kimi',
  'GPT',
  'Gemini',
];

function useNowTick(intervalMs = 1000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

function calcDelay(now) {
  const ms = Math.max(0, now - COMPLETION_DEADLINE);
  const days = Math.floor(ms / 86400000);
  const hours = Math.floor((ms % 86400000) / 3600000);
  const minutes = Math.floor((ms % 3600000) / 60000);
  const seconds = Math.floor((ms % 60000) / 1000);
  return { days, hours, minutes, seconds, totalMs: ms };
}

function DelayCounter({ delay }) {
  const pad = (n) => String(n).padStart(2, '0');
  const [capIdx, setCapIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      setCapIdx((prev) => (prev + 1) % CAPTIONS.length);
    }, 2000);
    return () => clearInterval(id);
  }, []);
  return (
    <div className="delay-banner">
      <div className="delay-banner__row">
        <span className="delay-banner__left">
          <span className="delay-banner__label">完工予定日より</span>
          <span className="delay-banner__days">{delay.days}</span>
          <span className="delay-banner__unit">日</span>
          <span className="delay-banner__hms">
            {pad(delay.hours)}:{pad(delay.minutes)}:{pad(delay.seconds)}
          </span>
        </span>
        <span className="delay-banner__caption">{CAPTIONS[capIdx]}</span>
      </div>
    </div>
  );
}

function App() {
  const now = useNowTick(1000);
  const delay = useMemo(() => calcDelay(now), [now]);

  return (
    <div className="page">
      <div className="tape tape--top" aria-hidden="true" />
      <DelayCounter delay={delay} />
      <div className="notice-wrap">
        <div className="notice-container">
          <h1>建築計画のお知らせ</h1>
          <table>
            <tbody>
              <tr>
                <th>建築物の名称</th>
                <td>おれんじのホームページ</td>
              </tr>
              <tr>
                <th>建築敷地の場所</th>
                <td>https://0ae.io</td>
              </tr>
              <tr>
                <th>用途</th>
                <td>自己紹介・5文字ドメイン自慢</td>
              </tr>
              <tr>
                <th>着工予定日</th>
                <td>2025年8月</td>
              </tr>
              <tr>
                <th>完了予定日</th>
                <td>2025年10月</td>
              </tr>
              <tr>
                <th>建築主</th>
                <td>@0_a_e</td>
              </tr>
              <tr>
                <th>設計者</th>
                <td>@0_a_e</td>
              </tr>
              <tr>
                <th>施工者</th>
                <td>
                  <div className="workers">
                    {WORKERS.map((w) => (
                      <span key={w} className="worker-name">
                        {w}
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
              <tr>
                <th>標識設置年月日</th>
                <td>2025年6月4日</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default App;